export default __webpack_public_path__ + "24f13d0b3202fb458e996c384f9b0c24.jpg";